import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { UIdModel } from '../../models/uid-model';
import { LoggerService } from 'src/app/services/logger.service';
import { uidViewModel } from '../../models/SalamatModel/salamat-prescription';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import * as _ from 'lodash-es';

@Component({
  selector: 'app-scan-barcode-modal-salamat',
  templateUrl: './scan-barcode-modal-salamat.component.html',
  styleUrls: ['./scan-barcode-modal-salamat.component.css'],
})
export class ScanBarcodeModalSalamatComponent implements OnChanges {
  @Input() drugId?: string;
  @Input() drugName?: string;
  @Input() UIDViewModel?: uidViewModel;
  public ActiveAddButton: boolean = false;
  @Input() barcodeList: UIdModel[] = [];
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();
  public loading: boolean = false;

  constructor(
    private logger: LoggerService,
    private apiService: UserApiService
  ) {
    if (this.barcodeList.length == 0) {
      this.barcodeList.push(new UIdModel(''));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['barcodeList']) {
      const newData = changes['barcodeList'].currentValue;

      if (newData == null || newData.length == 0) {
        setTimeout(() => {
          this.barcodeList = [];
          this.barcodeList.push(new UIdModel(''));
        }, 20);
      }
    }
  }

  public modalSuccessConfirm: boolean = false;

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
    }
  }

  public callParent(method: string, data: any) {
    this.parentActionOutput.emit(new PCTableOutputModel(method, data));
  }

  public addNewBarcode() {
    if (this.barcodeList == null) {
      this.barcodeList = [];
    }
    this.callParent('SaveUid', this.barcodeList);
    this.barcodeList.push(new UIdModel(''));
  }

  public saveBarcode(item) {
    // this.callParent('SaveUid', this.barcodeList);
    try {
      if (!this.UIDViewModel) {
        return;
      }
      this.loading = true;
      let backendJson = _.cloneDeep(this.UIDViewModel);
      backendJson.count = +item.count;
      backendJson.uId = item.uId;
      const url = `SaleElectronicPrescription/InquiryUIdSubscription`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (!result.succeeded) {
            this.apiService.AddErrorLog(result);
            return;
          }
          this.barcodeList.push(new UIdModel(''));
          item.active = false;
          this.callParent('succeedUploadData', backendJson);
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public removeBarcode(item) {
    // this.callParent('SaveUid', this.barcodeList);
    try {
      if (!this.UIDViewModel) {
        return;
      }
      this.loading = true;
      let backendJson = _.cloneDeep(this.UIDViewModel);
      backendJson.count = +item.count;
      backendJson.uId = item.uId;
      const url = `SaleElectronicPrescription/ReActiveUIdSubscription`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (!result.succeeded) {
            this.apiService.AddErrorLog(result);
            return;
          }
          const checkNew = this.barcodeList.find(
            (current) => current.uId == ''
          );
          if (!checkNew) {
            this.barcodeList.push(new UIdModel(''));
          }
          this.barcodeList = this.barcodeList.filter(
            (current) => current.uId != item.uId
          );
          item.active = false;
          this.callParent('succeedRemoveData', backendJson);
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public saveOnPrescription(){
    const prescriptionData={
      id:this.drugId,
      uIds:this.barcodeList
    }
    this.callParent('AddToPrescription',prescriptionData);
  }
}
